import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import classes from './AdminSetting.scss'

// Actions
import { bannerActions } from 'redux/actionCreators'

// Components
import { Loader } from 'components'

// Lodash
import _get from 'lodash.get'

class SettingSection extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired
  }

  render () {
    const { title, children } = this.props
    return (
      <div className={classes.settingSection}>
        <div className={classes.sectionTitle}>{title}</div>
        {children}
        <div className={classes.borderBottom} />
      </div>
    )
  }
}

class BannerConfig extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired,
    removing: PropTypes.bool.isRequired
  };

  static defaultProps = {
    label: '',
    saving: false,
    removing: false
  };

  constructor (props) {
    super(props)
    this.state = { title: props.title, link: props.link, version: props.version }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({ title: nextProps.title, link: nextProps.link, version: nextProps.version })
  }

  _onChange = (field) => (e) => { this.setState({ [field]: e.currentTarget.value }) }
  _onClick = () => { this.refs.fileChooser.click() }
  _onSelect = (e) => { this.setState({ file: e.currentTarget.files[0] }) }
  _onSave = () => this.props.onSave(this.state);

  render () {
    const { path, label, saving, removing, onRemove } = this.props
    return (
      <div className={classes.bannerConfig}>
        <div className={classes.row}>
          <div className={classes.label}>{label}</div>
          <input type='text' value={this.state.title} onChange={this._onChange('title')} />
        </div>
        <div className={classes.row}>
          <div className={classes.label}>*ลิงก์ไปที่</div>
          <input type='text' value={this.state.link} onChange={this._onChange('link')} />
        </div>
        <div className={classes.row}>
          <div className={classes.label}>ไฟล์รูป</div>
          <div className={classes.btnChooseFile} onClick={this._onClick}>
            <span>เลือกไฟล์</span>
          </div>
          <span className={classes.fileName}>{_get(this.state, ['file', 'name']) || 'ไม่ได้เลือกไฟล์ใด'}</span>
          <input ref='fileChooser' type='file' onChange={this._onSelect} />
        </div>
        {path && <div className={classes.row}><img src={`${path}?v=${this.state.version}`} role='presentation' /></div>}
        <div className={classes.row}>
          <div className={`${classes.btnSave} ${!(this.state.file || path) && classes.disabled}`} onClick={this._onSave}>
            {saving ? <Loader /> : <span>บันทึก</span>}
          </div>
          <div className={`${classes.btnRemove} ${!path && classes.disabled}`} onClick={path && onRemove}>
            {removing ? <Loader /> : <span>ลบ</span>}
          </div>
        </div>
      </div>
    )
  }
}

@connect(state => ({
  bannerMap: _get(state, ['banner', 'bannerMap']) || {},
  saveAttempting: _get(state, ['banner', 'saveAttempting']) || {},
  removeAttempting: _get(state, ['banner', 'removeAttempting']) || {}
}), dispatch => ({
  attemptFindBanners: () =>
    dispatch(bannerActions.attemptFindBanners()),
  attemptSaveBanner: (payload) =>
    dispatch(bannerActions.attemptSaveBanner(payload)),
  attemptRemoveBanner: (bannerKey) =>
    dispatch(bannerActions.attemptRemoveBanner({ bannerKey })),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
}))
class AdminSetting extends Component {
  static propTypes = {
    bannerMap: PropTypes.object.isRequired,
    attemptFindBanners: PropTypes.func.isRequired,
    attemptSaveBanner: PropTypes.func.isRequired,
    attemptRemoveBanner: PropTypes.func.isRequired
  };

  componentDidMount () {
    this.props.attemptFindBanners()
  }

  _bannerProps = (bannerKey) => ({
    ..._get(this.props, ['bannerMap', bannerKey]),
    saving: _get(this.props, ['saveAttempting', bannerKey]),
    removing: _get(this.props, ['removeAttempting', bannerKey]),
    onSave: (payload) => {
      this.props.attemptSaveBanner({ bannerKey: bannerKey, ...payload })
    },
    onRemove: () => this.props.attemptRemoveBanner(bannerKey)
  })

  render () {
    return (
      <section className={classes.setting}>
        <SettingSection title='แก้ไข Slider หน้าหลัก'>
          <BannerConfig label='หัวข้อ 1' {...this._bannerProps('home-slider1')} />
          <BannerConfig label='หัวข้อ 2' {...this._bannerProps('home-slider2')} />
          <BannerConfig label='หัวข้อ 3' {...this._bannerProps('home-slider3')} />
          <BannerConfig label='หัวข้อ 4' {...this._bannerProps('home-slider4')} />
        </SettingSection>
        <SettingSection title='แก้ไข Banner หน้าหลัก'>
          <BannerConfig label='หัวข้อ 1' {...this._bannerProps('home-banner1')} />
          <BannerConfig label='หัวข้อ 2' {...this._bannerProps('home-banner2')} />
          <BannerConfig label='หัวข้อ 3' {...this._bannerProps('home-banner3')} />
        </SettingSection>
        <SettingSection title='แก้ไข Banner หน้าตารางราคา'>
          <BannerConfig label='หัวข้อ' {...this._bannerProps('price-banner1')} />
        </SettingSection>
        <SettingSection title='แก้ไข Banner หน้ารายละเอียดสินค้า'>
          <BannerConfig label='หัวข้อ 1' {...this._bannerProps('product-banner1')} />
          <BannerConfig label='หัวข้อ 2' {...this._bannerProps('product-banner2')} />
          <BannerConfig label='หัวข้อ 3' {...this._bannerProps('product-banner3')} />
          <BannerConfig label='หัวข้อ 4' {...this._bannerProps('product-banner4')} />
          <BannerConfig label='หัวข้อ 5' {...this._bannerProps('product-banner5')} />
        </SettingSection>
      </section>
    )
  }
}

export default AdminSetting



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/AdminSetting/AdminSetting.js
 **/